jQuery(function ($) {
    $('.share-copy').on('click', function (e) {
        e.preventDefault();

        var parentContainer = $(this).closest('.share-group');
        var copiedMessage = parentContainer.find('.text-copied');

        var textToCopy = parentContainer.find('.share-copy-text').val();

        navigator.clipboard.writeText(textToCopy);
        copiedMessage.addClass('active');

        setTimeout(() => {
            copiedMessage.removeClass('active');
        }, 3000);

    });
});
